import React, { useEffect } from 'react';
import UiVersionPanel from '@srm/ui/shell/VersionPanel';
import { TITLE_PREFIX } from '@/configuration';
import { useActions } from '@hooks/useActions';
import { useTypedSelector } from '@hooks/useTypedSelector';

// Панель живёт в @srm/ui; название и версия — из конфигурации и стора Front.
const VersionPanel: React.FC = () => {
    const version = useTypedSelector((state) => state.appData.version);
    const { getVersion } = useActions();
    useEffect(() => {
        getVersion();
    }, []);

    return <UiVersionPanel appName={TITLE_PREFIX} version={version} />;
};

export default VersionPanel;
